"use strict";

import jQuery from 'jquery'
import $ from 'jquery'


var valGetParentContainer = function(element) {
    var element = $(element);

    if ($(element).closest('.form-group-sub').length > 0) {
        return $(element).closest('.form-group-sub')
    } else if ($(element).closest('.bootstrap-select').length > 0) {
        return $(element).closest('.bootstrap-select')
    } else {
        return $(element).closest('.form-group');
    }
}

jQuery.validator.setDefaults({
    errorElement: 'div', //default input error message container
    focusInvalid: false, // do not focus the last invalid input
    ignore: "",  // validate all fields including form hidden input

    errorPlacement: function(error, element) { // render error placement for each input type
        var element = $(element);

        var group = valGetParentContainer(element);
        var help = group.find('.form-text');

        if (group.find('.valid-feedback, .invalid-feedback').length !== 0) {
            return;
        }

        element.addClass('is-invalid');
        error.addClass('invalid-feedback');

        if (help.length > 0) {
            help.before(error);
        } else {
            if (element.closest('.bootstrap-select').length > 0) {     //Bootstrap select
                element.closest('.bootstrap-select').find('.bs-placeholder').after(error);
            } else if (element.closest('.input-group').length > 0) {   //Bootstrap group
                element.after(error);
            } else {                                                   //Checkbox & radios
                if (element.is(':checkbox')) {
                    element.closest('.kt-checkbox').find('> span').after(error);
                } else {
                    element.after(error);
                }                
            }            
        }
    },

    highlight: function(element) { // hightlight error inputs
        var group = valGetParentContainer(element);
        group.addClass('validate');
        group.addClass('is-invalid');
        $(element).removeClass('is-valid');
    },

    unhighlight: function(element) { // revert the change done by hightlight
        var group = valGetParentContainer(element);
        group.removeClass('validate'); 
        group.removeClass('is-invalid'); 
        $(element).removeClass('is-invalid');
    },

    success: function(label, element) {
        var group = valGetParentContainer(element);
        group.removeClass('validate');
        group.find('.invalid-feedback').remove();
    }
});

jQuery.validator.addMethod("email", function(value, element) {
    if (/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(value)) {
        return true;
    } else {
        return false;
    }
}, "Please enter a valid Email.");

// add fa messages
jQuery.extend( jQuery.validator.messages, {
	required: "تکمیل این فیلد اجباری است.",
	remote: "لطفا این فیلد را تصحیح کنید.",
	email: "لطفا یک ایمیل صحیح وارد کنید.",
	url: "لطفا آدرس صحیح وارد کنید.",
	date: "لطفا تاریخ صحیح وارد کنید.",
	dateFA: "لطفا یک تاریخ صحیح وارد کنید.",
	dateISO: "لطفا تاریخ صحیح وارد کنید (ISO).",
	number: "لطفا عدد صحیح وارد کنید.",
	digits: "لطفا تنها رقم وارد کنید.",
	creditcard: "لطفا کریدیت کارت صحیح وارد کنید.",
	equalTo: "لطفا مقدار برابری وارد کنید.",
	extension: "لطفا مقداری وارد کنید که",
	alphanumeric: "لطفا مقدار را عدد (انگلیسی) وارد کنید.",
	maxlength: jQuery.validator.format( "لطفا بیشتر از {0} حرف وارد نکنید." ),
	minlength: jQuery.validator.format( "لطفا کمتر از {0} حرف وارد نکنید." ),
	rangelength: jQuery.validator.format( "لطفا مقداری بین {0} تا {1} حرف وارد کنید." ),
	range: jQuery.validator.format( "لطفا مقداری بین {0} تا {1} حرف وارد کنید." ),
	max: jQuery.validator.format( "لطفا مقداری کمتر از {0} وارد کنید." ),
	min: jQuery.validator.format( "لطفا مقداری بیشتر از {0} وارد کنید." ),
	minWords: jQuery.validator.format( "لطفا حداقل {0} کلمه وارد کنید." ),
	maxWords: jQuery.validator.format( "لطفا حداکثر {0} کلمه وارد کنید." )
} );